export default function loggedin ({ from, to, next }) {
  var token = localStorage.getItem('token')
  if (token) {
    var application = localStorage.getItem('apn')
    if (application && application === 'active') {
      return next({
        name: 'mDashboard',
      })
    } else {
      return next({
        name: 'Dashboard',
      })
    }
  }
  return next()
}
